import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(modalAnatomy.keys);

export const Modal = defineMultiStyleConfig({
	baseStyle: {
		overlay: {
			bg: 'bg.overlayBackdrop',
		},
		content: {
			bgColor: 'bg.soft',
		},
		closeButton: {
			borderRadius: 'full',
			bgColor: 'grayAlpha.100',
			top: 3,
			_hover: {
				bgColor: 'grayAlpha.150',
			},
		},

		header: {
			borderBottomWidth: '1px',
			borderBottomStyle: 'solid',
			borderBottomColor: 'border.default',
		},
	},
});
